import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import { 
  Character 
} from "@dndModels";
import { DATA_TYPE_INFO } from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../utilities/common_utilities';

import CharacterSheet from "@dndComponents/character/CharacterSheet";
import LoadingBox from "@components/input/LoadingBox";
import CharacterSaveTools from "@dndComponents/character/misc/CharacterSaveTools";

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterShared() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [percentage, setPercentage] = useState(0);
  // const [last_reload, setLastReload] = useState(0);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [logging_in, setLoggingIn] = useState(false);
  // const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Character>(new Character());
  
  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      if (api.user === null) {
        const userObjStr = localStorage.getItem("loginUser");
        if (!userObjStr) {
          load();
        } else {
          setLoggingIn(true);
          setLoadingMessage("Logging in");
          check_login();
        }
      } else {
        load();
      }
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const check_login = () => {
    setTimeout(() => {
      if (api.user === null) {
        check_login();
      } else {
        load();
      }
    }, 1000);
  }

  const load = () => {
    setLoading(true);
    if (id && id !== "") {
      load_object(id);
    } else {
      setLoadingMessage("Shared Character Not Found");
    }
    setLoggingIn(false);
    setFetched(true);
  }

  // Loads the editing Character into state
  const load_object = (id: string) => {
    const onProgress = (data_type: string, percent: number ) => {
      const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
      if (dt_info) {
        setPercentage(percent * 100);
        setLoadingMessage(`Loading ${dt_info.plural}`);
      }
    };
    const onError = (message: string) => {
      setLoadingMessage(message);
    };
    char_util.getSharedCharacter({ id, onProgress, onError }).then(res => {
      if (res) {
        setObj(res);
        setLoading(false);
      } else {
        setLoadingMessage("Shared Character Not Found");
      }
    });
  }

  const updateCharacter = (character: Character, pieces: string[]) => {
    if (pieces.length !== 1 || pieces[0] !== "reload") {
      character.changed();
      // setLastReload(common_util.get_time_number());
      setObj(character);
    } else {
      setObj(character);
      setReloading(true);
    }
  }

  if (!fetched || logging_in || loading) {
    const height = window.innerHeight - 64;
    return (<LoadingBox message={loading_message} percentage={percentage} size={height * 0.5} height={height} width={window.innerWidth} />);
  // } else if (navigateTo !== null) {
  //   return <Navigate to={navigateTo} />;
  } else if (logging_in) {
    return <span>Logging in</span>;
  // } else if (api.user === null) {
  //   return <Navigate to="/labs" />;
  } else { 
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterSaveTools
            character={obj}
            // last_reload={last_reload}
            // onReload={(changed: Character) => {
            //   updateCharacter(changed, ["reload"]);
            // }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          { !reloading && 
            <CharacterSheet
              character={obj}
              shared
            />
          }
        </Grid>
      </Grid>
    ); 
    // return (
    //   <CharacterSheet
    //     char_id={obj._id}
    //     character={obj}
    //     height={window.innerHeight}
    //     width={window.innerWidth}
    //     shared
    //     updateCharacter={(obj: Character, pieces: string[] = ["all"]) => {
    //       updateCharacter(obj, pieces);
    //     }}
    //   />
    // ); 
  }
}
